<div class="relative">
  <input
    [type]="type()"
    [formControl]="control()"
    [placeholder]="placeholder()"
    [class.border-th-red]="(control().invalid && showErrors()) || formGroupError()"
    [class.border-th-dark-blue]="!(control().invalid && showErrors()) && !formGroupError()"
    class="peer w-full px-4 py-3 border-2 rounded-lg text-th-dark-blue text-[16px] font-medium focus:outline-none focus:border-th-blue-highlight-2"
  />
  <label
    [class.text-th-red]="(control().invalid && showErrors()) || formGroupError()"
    class="absolute left-3 -top-2.5 bg-white px-1 text-th-dark-blue font-medium transition-all pointer-events-none peer-placeholder-shown:text-[16px] peer-placeholder-shown:text-th-blue-placeholder peer-placeholder-shown:top-3 peer-placeholder-shown:left-4 peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-[12px] peer-focus:text-th-dark-blue peer-not-placeholder-shown:text-[12px]"
  >
    {{ label() }}
  </label>
  <button
    type="button"
    (click)="showPassword()"
    class="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer"
  >
    @if (!show()) {
      <img src="icons/show_eye.svg" alt="Mostrar" />
    }
    @if (show()) {
      <img src="icons/hide_eye.svg" alt="Ocultar" />
    }
  </button>
</div>

@if (formGroupError()) {
  <p class="text-th-red font-semibold text-[12px] mt-1 px-0.5">Las contraseñas no coinciden</p>
}
